import Store from 'fluxible/addons/BaseStore';
import {
  setAccessibilitySettings,
  getAccessibilitySettings,
} from './localStorage';

/**
 * REIS-204 WCAG 1.4.3 / 1.4.11 (G174): user-toggleable high
 * contrast mode. The map switches to a high-contrast tile variant and the
 * `high-contrast` class on <html> activates the stronger color palette in
 * stylesheets and components.
 */
class AccessibilityStore extends Store {
  static handlers = {
    UpdateHighContrast: 'updateHighContrast',
  };

  static storeName = 'AccessibilityStore';

  highContrast = false;

  constructor(dispatcher) {
    super(dispatcher);
    const stored = getAccessibilitySettings();
    this.highContrast = !!stored.highContrast;
    this.applyRootClass();
  }

  getHighContrast = () => this.highContrast;

  updateHighContrast = value => {
    this.highContrast = !!value;
    setAccessibilitySettings({ highContrast: this.highContrast });
    this.applyRootClass();
    this.emitChange();
  };

  applyRootClass = () => {
    if (typeof document !== 'undefined') {
      document.documentElement.classList.toggle(
        'high-contrast',
        this.highContrast,
      );
    }
  };
}

export default AccessibilityStore;
